<adapt-feature-guidance [configItem]="configItem">
    <p>
        Control what notifications you receive for activities in
        {{ projectLabel }}.
    </p>
</adapt-feature-guidance>

<ng-container *adaptLoading="!person">
    <dx-check-box class="d-block"
                  text="Send me a daily summary email of activities relevant to me that were changed by other people"
                  [(ngModel)]="person!.preferences.notifyDailySummary"></dx-check-box>
    <dx-check-box class="d-block mt-1"
                  text="Send me a weekly summary email of activities relevant to me that are due in the coming week"
                  [(ngModel)]="person!.preferences.notifyUpcomingDueActivities"></dx-check-box>

    <div role="alert"
         class="alert alert-warning mt-3 mb-0">
        Note: These settings are system wide settings.
        <br />
        If you are subscribed to multiple organisations, these settings apply to all organisations.
    </div>
</ng-container>
